import React from "react";
import PropTypes from "prop-types";
import injectSheet from "react-jss";
import { connect } from "react-redux";
import { getModal } from "./reducer";
import { setModal } from "./actions";
import { getValue } from "../Reducers/reducer";
import { setValue } from "../Reducers/actions";
import ButtonDevice from "./ButtonDevice";

const style = {
  box: {
    display: "flex",
    width: 1170,
    height: 640,
    position: "absolute",
    justifyContent: "center",
    animation: "fade-in 0.3s",
    zIndex: 1,
    backgroundColor: "rgba(242, 242, 242, 0.5)"
  },
  modalBox: {
    height: 310,
    width: 973,
    borderTop: "3px solid #0E283D",
    border: "1px solid #F2F2F2",
    borderRadius: "0 0 3px 3px",
    backgroundColor: "#FFFFFF",
    margin: "117px 0px 6px 0px",
    boxShadow: "0 0 32px 0 rgba(71,74,74,0.2)"
  },
  text: {
    display: "flex",
    width: 330,
    margin: "78px 0px 40px 318px",
    textAlign: "center",
    fontSize: 20
  }
};

const Modal = ({ classes, objectModal, onChangeDevice, onChangeModal }) => {
  const isVisible = objectModal.isVisible;

  if (!isVisible) {
    return null;
  }
  return (
    <div className={classes.box}>
      <div className={classes.modalBox}>
        <span className={classes.text}>
          How many devices would you like to activate, in average?
        </span>
        <ButtonDevice
          onChangeDevice={onChangeDevice}
          onChangeModal={onChangeModal}
        />
      </div>
    </div>
  );
};

Modal.propTypes = {
  classes: PropTypes.object.isRequired,
  objectDevice: PropTypes.object.isRequired,
  objectModal: PropTypes.object.isRequired,
  onChangeDevice: PropTypes.func.isRequired,
  onChangeModal: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  objectDevice: getValue(state),
  objectModal: getModal(state)
});

const mapDispatchToProps = {
  setValue,
  setModal
};

const mergeProps = (state, actions, props) => {
  return {
    ...state,
    onChangeDevice(total) {
      actions.setValue({
        device: total,
        updateSize: state.objectDevice.updateSize,
        rollout: state.objectDevice.rollout,
        percentualDevice: state.objectDevice.percentualDevice
      });
    },
    onChangeModal(total) {
      actions.setModal({
        isVisible: total
      });
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(injectSheet(style)(Modal));
